import { useAppContext } from '../../context/AppContext';

export default function StatsPage() {
  const { articles, decks, savedWords } = useAppContext();

  const stats = [
    { label: 'Articles Parsed', value: articles.length, icon: '📖' },
    { label: 'Decks Created', value: decks.length, icon: '🗂' },
    { label: 'Words Saved', value: savedWords.length, icon: '📝' },
  ];

  const deckBreakdown = decks.map(deck => ({
    ...deck,
    wordCount: savedWords.filter(w => w.deckId === deck.id).length,
  }));

  return (
    <div className="p-4 pt-14 md:p-8 max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">Stats</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">Your learning progress at a glance</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
        {stats.map(stat => (
          <div key={stat.label} className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
            <div className="text-3xl mb-2">{stat.icon}</div>
            <div className="text-3xl font-bold text-slate-800 dark:text-slate-100">{stat.value}</div>
            <div className="text-sm text-slate-500 dark:text-slate-400 mt-1">{stat.label}</div>
          </div>
        ))}
      </div>

      {deckBreakdown.length > 0 && (
        <div>
          <h2 className="text-lg font-semibold text-slate-700 dark:text-slate-200 mb-4">Words per Deck</h2>
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
            <ul className="divide-y divide-slate-100 dark:divide-slate-700">
              {deckBreakdown.map(deck => (
                <li key={deck.id} className="flex items-center justify-between px-5 py-3">
                  <span className="text-sm font-medium text-slate-700 dark:text-slate-200">{deck.name}</span>
                  <span className="bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 px-2.5 py-0.5 rounded-full text-xs font-medium">
                    {deck.wordCount} word{deck.wordCount !== 1 ? 's' : ''}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {articles.length === 0 && decks.length === 0 && (
        <div className="text-center py-12">
          <p className="text-slate-400 text-sm">Start by parsing an article or creating a deck to see your stats here.</p>
        </div>
      )}
    </div>
  );
}
